<template>
  <div class="completed">
    {{msg}}
    <div v-if="msg==0">
      <div class="card" v-for="(item, index) in tableData" :key="index" @click="enterDetail(item)">
        <div class="proName">{{ item.proName }}</div>
        <img src="../../assets/img/continue.png" alt="" class="cardImg" v-if="item.code == 0" />
        <img src="../../assets/img/finish.png" alt="" class="cardImg" v-if="item.code == 1" />
        <img src="../../assets/img/cancel.png" alt="" class="cardImg" v-if="item.code == 2" />
        <div class="concat">
          <span>{{ item.name }}</span>
          <span>{{ item.phone }}</span>
        </div>
        <div class="concat_name">
          <span>{{ item.time }}</span>
          <span>{{ item.nurse }}</span>
        </div>
      </div>
    </div>
    <div v-if="msg==1">
      <!-- <div class="card" v-for="(item, index) in tableData" :key="index" @click="enterDetail(item)">
        <div class="proName">{{ item.proName }}</div>
        <img src="../../assets/img/continue.png" alt="" class="cardImg" v-if="item.code == 0" />
        <img src="../../assets/img/finish.png" alt="" class="cardImg" v-if="item.code == 1" />
        <img src="../../assets/img/cancel.png" alt="" class="cardImg" v-if="item.code == 2" />
        <div class="concat">
          <span>{{ item.name }}</span>
          <span>{{ item.phone }}</span>
        </div>
        <div class="concat_name">
          <span>{{ item.time }}</span>
          <span>{{ item.nurse }}</span>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import {
  findAppointmentList,
} from "@/axios/api";
export default {
  props: ['msg'],
  data() {
    return {
      // 0待完成1已完成2已取消
      tableData: [{
        proName: "水光针",
        name: "桃白白",
        phone: "45123652356",
        time: "07-06 12:00",
        nurse: "刘某某",
        code: 0,
      },
      {
        proName: "水光针",
        name: "桃白白",
        phone: "45123652356",
        time: "07-06 12:00",
        nurse: "刘某某",
        code: 1,
      },
      {
        proName: "水光针",
        name: "桃白白",
        phone: "45123652356",
        time: "07-06 12:00",
        nurse: "刘某某",
        code: 2,
      },
      ],
      empId: '',
      userStatus: '',
      doctorNo: ''
    };
  },
  created() {
    this.appointmentList()
    this.empId = JSON.parse(localStorage.getItem('userInfo')).empId
    this.userStatus = JSON.parse(localStorage.getItem('userInfo')).status
    this.doctorNo = JSON.parse(localStorage.getItem('userInfo')).doctorNo
    console.log(this.empId)
  },
  methods: {
    // 点击进入详情页
    enterDetail(item) {
      console.log(item)
      // this.$router.push("/appointDetail")
      this.$router.push({
        name: 'appointDetail',
        params: item
      })

    },
    // 查询预约列表
    appointmentList() {
      findAppointmentList({
        doctorId: "",
        instrumentId: "",
        projectId: "",
        positionId: "",
        appointmentTime: "",
        operationStatus: 1,
        userId: this.empId,
        userStatus: this.userStatus,
        doctorNo: this.doctorNo,
        areaType: localStorage.getItem('areaType'),
        areaCode: localStorage.getItem('areaType')
      })
        .then((res) => {
          console.log(res.data);
          if (res.result == true) {
            this.textList = res.data;
          } else {
            this.$toast.error(res.errMsg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  }
};

</script>
<style scoped>
@import "../../assets/css/completed.css";
</style>



// WEBPACK FOOTER //
// src/components/page/completed.vue